import { Button, Row } from "antd"
import styles from "@/styles/view-cart.module.scss"

interface CartHeaderProps {
  onCheckout: () => void
}

const CartHeader = ({ onCheckout }: CartHeaderProps) => (
  <Row align="middle" justify="space-between">
    <div className={styles['table-title']}>Your Shopping Cart</div>
    <div>
      <Button href="/" type="primary" ghost style={{ fontWeight: 'bold' }}>Continue Shopping</Button>
      <Button onClick={onCheckout} type="primary" style={{ marginLeft: '8px', fontWeight: 'bold' }}>Checkout</Button>
    </div>
  </Row>
)

export default CartHeader
